import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../lib/api';
import FacilitatorDetail from './FacilitatorDetail';

// Old /facilitators/:id links now resolve to the unified teacher profile.
// Falls back to the legacy facilitator page only if no unified record exists yet.
const FacilitatorRedirect = () => {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, slug: null });

  useEffect(() => {
    let active = true;
    api.get(`/teachers/resolve/${id}`)
      .then((r) => active && setState({ loading: false, slug: r.data?.slug || null }))
      .catch(() => active && setState({ loading: false, slug: null }));
    return () => { active = false; };
  }, [id]);

  if (state.loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-mahogany"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }
  if (state.slug) return <Navigate to={`/teachers/${state.slug}`} replace />;
  return <FacilitatorDetail />;
};

export default FacilitatorRedirect;
